<template>
  <MainLayout>
    <Head title="Parts" />

    <template v-slot:header>Parts</template>

    <div class="mb-4" v-if="$can('parts.write')">
      <ButtonGroup>
        <Link :href="$route('parts.create')">Add Part</Link>
        <button type="button" @click="sync"><RefreshIcon class="w-4 h-4 mr-2" /> Sync options</button>
      </ButtonGroup>
    </div>

    <FormWrapper grid>
      <form @submit.prevent="submit">
        <FormInput name="name"
                   label="Form"
                   v-model="form.search"
                   class="sm:col-span-6"/>

        <FormActions :show-cancel="false"
                     submit-label="Search"
                     grid />
      </form>
    </FormWrapper>

    <DataTable :pagination="parts" class="mt-4">
      <template v-slot:header>
        <th scope="col" class="">
          SKU
        </th>
        <th scope="col">
          Price
        </th>
        <th scope="col">
          <span class="sr-only">Edit</span>
        </th>
      </template>

      <tr v-for="part in parts.data" :key="part.id">
        <td>{{ part.sku }}</td>
        <td>${{ part.retail_price }}</td>
        <td>
          <div class="flex gap-2 place-content-end">
            <button type="button"
                    class="text-red-600 hover:text-red-900"
                    v-if="$can('builds.write')"
                    @click="deletePart(part)">Delete</button>
            <Link :href="$route('parts.edit', [part.id])" class="text-indigo-600 hover:text-indigo-900">Edit</Link>
          </div>
        </td>
      </tr>
    </DataTable>
  </MainLayout>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import PageComponent from '@/pages/page-component'
import DataTable from '@/components/data-table.vue'
import FormComponent from '@/pages/form-component'
import {
  RefreshIcon,
} from '@heroicons/vue/solid'
import { Inertia } from '@inertiajs/inertia'
import UsesPermissions from '@/mixins/uses-permissions'

export default {
  mixins: [
    PageComponent,
    FormComponent,
    UsesPermissions,
  ],

  components: {
    DataTable,
    Link,
    RefreshIcon,
  },

  props: {
    parts: Object,
    search: String,
  },

  data() {
    return {
      form: {
        search: this.search,
      }
    }
  },

  methods: {
    submit() {
      Inertia.get(this.$route('parts.index'), this.form)
    },

    deletePart (part) {
      if (confirm('Are you sure?')) {
        Inertia.delete(this.$route('parts.destroy', [part.id]))
      }
    },

    sync() {
      const warning = "Warning: this action will overwrite existing options mapping. Do you want to continue?"

      if (confirm(warning)) {
        Inertia.post(this.$route('parts.sync-options'))
      }
    }
  },
}
</script>
